<template>
  <article :class="$style.card" :style="{ backgroundColor: car.bgColor }">
    <div :class="$style.card__icon">
      <IconSuv v-if="car.name === 'SUVs'" />
      <IconLuxury v-else-if="car.name === 'Luxury'" />
      <IconSedan v-else />
    </div>
    <div>
      <h2 :class="$style.card__title">{{ car.name }}</h2>
    </div>
    <div>
      <p :class="$style.card__content">
        <span>{{ car.description }}</span>
      </p>
    </div>
    <a
      :href="car.link"
      target="_blank"
      :class="$style.card__link"
      :style="{ color: car.bgColor }"
    >
      Learn More
    </a>
  </article>
</template>

<script>
import IconSedan from "../Icons/IconSedan.vue";
import IconSuv from "../Icons/IconSuv.vue";
import IconLuxury from "../Icons/IconLuxury.vue";

export default {
  name: "BaseCard",
  components: {
    IconSedan,
    IconSuv,
    IconLuxury,
  },
  props: {
    car: Object,
  },
};
</script>

<style lang="scss" module>
@use './BaseCard';
</style>
